import React from 'react';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import { t, defineMessages } from '@sm/intl';
import { withWebAssetsTheme } from '../../theme';
import { ClientError, ClientErrorProps } from '../ClientError';
import SignupButton, { SignupButtonProps } from '../ClientError/SignupButton';
import Links, { LinksProps } from '../ClientError/Links';

export type FourOhFourErrorProps = Partial<ClientErrorProps> & {
  errorMessage?: React.ReactNode;
  signupButtonProps?: SignupButtonProps;
  linksProps?: LinksProps;
  showLinks?: boolean;
};

const COPY = defineMessages({
  SORRY_MESSAGE: {
    id: 'FourOhFourError.sorryMessage',
    defaultMessage: "We're sorry",
    description: '[Type: Label][Vis.: med] - We are sorry message',
  },
  CANT_FIND_PAGE: {
    id: 'FourOhFourError.cantFindPage',
    defaultMessage: "We can't find the page you're looking for.",
    description: '[Type: Label][Vis.: med] - Cant find page message',
  },
  CHECK_URL: {
    id: 'FourOhFourError.checkURL',
    defaultMessage:
      "Please check the URL you entered to make sure it's spelled correctly.",
    description: '[Type: Label][Vis.: med] - check URL subtitle',
  },
  HELP_FIND_WAY: {
    id: 'FourOhFourError.helpFindWay',
    defaultMessage:
      'Still not sure how to get to the page you want? Maybe we can help you find your way:',
    description: '[Type: Label][Vis.: med] - Help find your way subtitle',
  },
});

/* The default component for 404 error message */
function FourOhFourError({
  openingMessage = t(COPY.SORRY_MESSAGE),
  errorTitle = t(COPY.CANT_FIND_PAGE),
  titularElementTag = 'p',
  errorMessage = [t(COPY.CHECK_URL), t(COPY.HELP_FIND_WAY)],
  signupButtonProps,
  linksProps,
  showLinks = false,
  testId = 'FourOhFourError',
}: FourOhFourErrorProps): React.ReactElement {
  return (
    <ClientError
      openingMessage={openingMessage}
      errorTitle={errorTitle}
      titularElementTag={titularElementTag}
      testId={testId}
    >
      <Box p={1}>
        <Typography component="div" variant="body" align="center">
          {React.Children.map(errorMessage, (message: React.ReactNode) => {
            return <p data-testid="FourOhFourError_ErrorMessage">{message}</p>;
          })}
        </Typography>
      </Box>
      <SignupButton {...signupButtonProps} />
      {showLinks && <Links {...linksProps} />}
    </ClientError>
  );
}

export default withWebAssetsTheme(FourOhFourError);
